import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { CmsConfigSchema } from '../markets/cmsConfig';
const ibeApiBase = () => {
    const fromEnv = process.env.IBE_API_URL;
    if (!fromEnv) {
        throw new Error('IBE_API_URL is not configured');
    }
    return fromEnv.replace(/\/$/, '');
};
// The IBE CMS config powers the city/region → property mappings. It is a public
// (unauthenticated) read shared with the IBE frontend, so no auth header is
// attached here — unlike the Cognito-fronted `offersApi`.
export const cmsConfigApi = createApi({
    reducerPath: 'cmsConfigApi',
    baseQuery: fetchBaseQuery({ baseUrl: ibeApiBase() }),
    endpoints: builder => ({
        getCmsConfig: builder.query({
            query: () => '/config',
            transformResponse: (response) => CmsConfigSchema.parse(response),
            // The mapping data changes rarely; cache it for the whole session.
            keepUnusedDataFor: 3600
        })
    })
});
export const { useGetCmsConfigQuery } = cmsConfigApi;
